import { render } from "./FrequencyTable.vue?vue&type=template&id=7bba25f4"
import script from "./FrequencyTable.vue?vue&type=script&lang=js"
export * from "./FrequencyTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__